import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, InfoIcon, ExternalLinkIcon } from 'lucide-react';
export function VampDetail() {
  const navigate = useNavigate();
  const [showFraudTooltip, setShowFraudTooltip] = useState(false);
  const [showCardTestingTooltip, setShowCardTestingTooltip] = useState(false);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return <div className="max-w-7xl mx-auto" data-id="element-9294">
      {/* Breadcrumb */}
      <div className="mb-6" data-id="element-9295">
        <button onClick={() => navigate('/card-monitoring')} className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9296">
          <ChevronLeftIcon size={16} data-id="element-9297" />
          <span data-id="element-9298">Card monitoring programs</span>
        </button>
      </div>

      {/* Header */}
      <div className="mb-8" data-id="element-9299">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-9300">
          Visa Acquirer Monitoring Program (VAMP)
        </h1>
        <p className="text-gray-600" data-id="element-9301">
          View your monitoring program status and history.
        </p>
      </div>

      {/* History Section */}
      <div className="mb-12" data-id="element-9302">
        <div className="flex items-center gap-2 mb-2" data-id="element-9303">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-9304">History</h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-9305">
            <InfoIcon size={16} data-id="element-9306" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-9307">
          Your program history for the last 12 months.
        </p>

        {/* History Table */}
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-9308">
          <table className="w-full" data-id="element-9309">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-9310">
              <tr data-id="element-9311">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-9312">
                  Program type
                </th>
                {months.map(month => <th key={month} className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider" data-id="element-9313">
                    {month}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-9314">
              {/* Fraud and disputes row */}
              <tr className="hover:bg-gray-50" data-id="element-9315">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-9316">
                  <div className="flex items-center gap-2" data-id="element-9317">
                    <span className="text-sm text-gray-900" data-id="element-9318">
                      Fraud and disputes
                    </span>
                    <div className="relative" data-id="element-9319">
                      <button onMouseEnter={() => setShowFraudTooltip(true)} onMouseLeave={() => setShowFraudTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-9320">
                        <InfoIcon size={14} data-id="element-9321" />
                      </button>
                      {showFraudTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-9322">
                          Measures fraud and disputes against the total number
                          of settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-9323"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-9324">
                    {index === 11 ? <div className="flex justify-center" data-id="element-9325">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-9326"></div>
                      </div> : <div className="flex justify-center" data-id="element-9327">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-9328"></div>
                      </div>}
                  </td>)}
              </tr>

              {/* Card testing row */}
              <tr className="hover:bg-gray-50" data-id="element-9329">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-9330">
                  <div className="flex items-center gap-2" data-id="element-9331">
                    <span className="text-sm text-gray-900" data-id="element-9332">Card testing</span>
                    <div className="relative" data-id="element-9333">
                      <button onMouseEnter={() => setShowCardTestingTooltip(true)} onMouseLeave={() => setShowCardTestingTooltip(false)} className="text-gray-400 hover:text-gray-600" data-id="element-9334">
                        <InfoIcon size={14} data-id="element-9335" />
                      </button>
                      {showCardTestingTooltip && <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-10 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg whitespace-normal" data-id="element-9336">
                          Measures card testing against the total number of
                          settled payments
                          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-gray-900" data-id="element-9337"></div>
                        </div>}
                    </div>
                  </div>
                </td>
                {months.map((month, index) => <td key={month} className="px-4 py-4 text-center" data-id="element-9338">
                    {index === 11 ? <div className="flex justify-center" data-id="element-9339">
                        <div className="animate-spin h-4 w-4 border-2 border-gray-300 border-t-blue-600 rounded-full" data-id="element-9340"></div>
                      </div> : <div className="flex justify-center" data-id="element-9341">
                        <div className="w-3 h-3 bg-gray-300 rounded-full" data-id="element-9342"></div>
                      </div>}
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Historical and current program status */}
      <div className="mb-12" data-id="element-9343">
        <div className="flex items-center gap-2 mb-2" data-id="element-9344">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-9345">
            Historical and current program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-9346">
            <InfoIcon size={16} data-id="element-9347" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-9348">
          Visa-identified fraud and disputes against the total number of settled
          payments
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-9349">
          <p className="text-center text-gray-500" data-id="element-9350">No past history found.</p>
        </div>
      </div>

      {/* Estimated program status */}
      <div className="mb-12" data-id="element-9351">
        <div className="flex items-center gap-2 mb-2" data-id="element-9352">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-9353">
            Estimated program status
          </h2>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-9354">
            <InfoIcon size={16} data-id="element-9355" />
          </button>
        </div>
        <p className="text-sm text-gray-600 mb-6" data-id="element-9356">
          Maybank's estimate of your Visa frauds and disputes. Aim to keep your
          VAMP ratio under 0.5%.{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-9357">
            Learn more
          </a>{' '}
          about how to keep your disputes and fraud low.
        </p>

        <div className="bg-white border border-gray-200 rounded-lg p-8" data-id="element-9358">
          <p className="text-center text-gray-500" data-id="element-9359">No past history found.</p>
        </div>
      </div>

      {/* Resources */}
      <div data-id="element-9360">
        <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-9361">Resources</h2>
        <div className="flex flex-wrap gap-4" data-id="element-9362">
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9363">
            <ExternalLinkIcon size={14} data-id="element-9364" />
            Program overview
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9365">
            <ExternalLinkIcon size={14} data-id="element-9366" />
            Preventing fraud and disputes
          </a>
          <a href="#" className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-9367">
            <ExternalLinkIcon size={14} data-id="element-9368" />
            Preventing card testing
          </a>
        </div>
      </div>
    </div>;
}